import { combineReducers } from 'redux'

import { ContatoState } from './contato/types'
import contato from './contato'
import { ContratosState } from './contratos/types'
import contratos from './contratos'
import { SimulacaoState } from './simulacao/types'
import simulacao from './simulacao'
import { DadosPessoaisState } from './dadosPessoais/types'
import dadosPessoais from './dadosPessoais'
import { ValidaState } from './validateISafe/types'
import valida from './validateISafe'
import { ListaDocumentosState } from './listaDocumentos/types'
import listaDocumentos from './listaDocumentos'
import { DocumentosAssinaturaState } from './documentosAssinatura/types'
import documentosAssinatura from './documentosAssinatura'
import { PropostaState } from './proposta/types'
import proposta from './proposta'
import { DocumentosState } from './documentos/types'
import documentos from './documentos'
import { FotoDocumentosState } from './fotoDocumentos/types'
import fotoDocumentos from './fotoDocumentos'
import { DadosBancariosState } from './dadosBancarios/types'
import dadosBancarios from './dadosBancarios'
import { MarginAcceptResultState } from './marginAcceptResult/types'
import marginAcceptResult from './marginAcceptResult'
import { EnderecoState } from './endereco/types'
import endereco from './endereco'
import contrachequeDocumentos from './contrachequeDocumentos'
import { ContrachequeDocumentosState } from './contrachequeDocumentos/types'
import contratacao, { ContratacaoState } from './contratacao'
import { AuthenticationState } from './authentication/types'
import authentication from './authentication'

export interface RefinanciamentoState {
  contato: ContatoState
  contratos: ContratosState
  simulacao: SimulacaoState
  dadosPessoais: DadosPessoaisState
  marginAcceptResult: MarginAcceptResultState
  valida: ValidaState
  listaDocumentos: ListaDocumentosState
  documentosAssinatura: DocumentosAssinaturaState
  proposta: PropostaState
  documentos: DocumentosState
  fotoDocumentos: FotoDocumentosState
  contrachequeDocumentos: ContrachequeDocumentosState
  dadosBancarios: DadosBancariosState
  endereco: EnderecoState
  contratacao: ContratacaoState
  authentication: AuthenticationState
}

export default combineReducers({
  contato,
  contratos,
  simulacao,
  dadosPessoais,
  marginAcceptResult,
  valida,
  listaDocumentos,
  documentosAssinatura,
  proposta,
  documentos,
  fotoDocumentos,
  contrachequeDocumentos,
  dadosBancarios,
  endereco,
  contratacao,
  authentication,
})
